import { ClientEventEmitter } from '../../marketing/ClientEventEmitter';
import { ClientEvents } from '../../constants/clientEvents';

type HeroLevelUpData = {
    level: number;
};

export class HeroLevelUpHandler {
    public handle(data: HeroLevelUpData): void {
        ClientEventEmitter.fireEvent(ClientEvents.HERO_LEVEL_UP, data);
    }
}
